import { Button, Flex, Icon, Stack, Text } from "@chakra-ui/react";
import { RiArrowRightLine, RiMap2Line, RiPhoneLine, RiProfileLine, RiUser3Line } from "react-icons/ri";
import { useHistory } from "react-router-dom";

import { useCart } from "../../hooks/cart";

type ClienteData = {
	id: string;
	nome: string;
	doc: string;
	phone: string;
	cid: string;
}
interface DataTableCardsParams {
	clientes: ClienteData[];
}

const DataTableCards: React.FC<DataTableCardsParams> = ({ clientes }) => {
	const { addCartCliente } = useCart();
	const history = useHistory();

	return (
		<Flex w="100%" flexDir="column" justify="center" align="center">
			{clientes.map((cliente, indice) => {
				return (
					<Flex
						key={indice}
						justify="space-between"
						w="100%"
						bgGradient='linear(to-r, gray.50, gray.100)'
						borderRadius={8}
						boxShadow='xl'
						p="4"
						m="4"
					>
						<Flex>
							<Stack>
								{cliente.nome && (
									<Flex align="center">
										<Icon as={RiUser3Line} fontSize="16" mr="2" />
										<Text
											color="gray.800"
											textTransform="uppercase"
											fontWeight="500"
											fontSize="14"
										>
											{cliente.nome}
										</Text>
									</Flex>		
								)}

								{cliente.phone && (
									<Flex align="center">
										<Icon as={RiPhoneLine} fontSize="16" mr="2" />
										<Text color="gray.500" fontSize="14">{cliente.phone}</Text>
									</Flex>
								)}

								{cliente.doc && (
									<Flex align="center">
										<Icon as={RiProfileLine} fontSize="16" mr="2" />
										<Text color="gray.600" fontSize="14">{cliente.doc}</Text>
									</Flex>
								)}

								{cliente.cid && (
									<Flex align="center">
										<Icon as={RiMap2Line} fontSize="16" mr="2" />
										<Text color="gray.800" fontSize="14">{cliente.cid}</Text>
									</Flex>
								)}
							</Stack>
						</Flex>

						<Flex flexDir="column" justify="end">
							<Stack direction="column" justify="space-between" align="end">
								<Button
									bg="transparent"
									p={0}
									m={0}
									onClick={() => {
										addCartCliente(cliente, false);
										history.push('/products');
									}}
								>
									<Icon as={RiArrowRightLine} color="blue.100" fontSize="24" />
								</Button>
							</Stack>
						</Flex>
					</Flex>
				)
			})}
		</Flex>
	)
}

export default DataTableCards;